import React from "react";
import {
  CloseTag
} from "../../../../../../CommonComponents/RecommendFlow/GenericStepper/components/styles";
import EditLinkToPill from "../../../../../../CommonComponents/EditLinkToPill/EditLinkToPill";
import { formatAmount } from "../../../../../../utils/commonUtil";
import close from '../../../../../../assets/icons/close-circle.svg'

export const OneTimeExchangeStep1 = props => {
  const { amountFrom, amountTo, type, poolCount, analyticsTracking } = props;
  const formatType = type => {
    if (type == "exchangeFromTIFF") {
      return "Exchange from TIFF";
    } else {
      return "Exchange into TIFF";
    }
  };
  const renderInfoStep1 = () => (
    <>
      <div data-test="wrapper">
        <div>Schedule type: TIFF Exchange </div>
        <div>{formatType(type)} </div>
        <div>
          Total Amount: {type == "exchangeFromTIFF" ? formatAmount(amountFrom) : formatAmount(amountTo)}
        </div>
        {props.type !== "exchangeFromTIFF" && (
          <div>Pools: {poolCount}</div>
        )}
      </div>
      <EditLinkToPill
        prefixId="step1"
        analyticsTracking={(value) => analyticsTracking && analyticsTracking(value)}
        linkPathname="/investments/recommend-an-exchange-tiff"
        pageName="fromPool"
      />
    </>
  );
  return renderInfoStep1();
};

export const TIffStep2 = props => {
  const renderInfoStep2 = () => (
    <>
      <div>
        <div>Total Amount: {formatAmount(props.valueTiffExchangeAmount)} </div>
        <div>No. of Pools Selected: {props.poolCount}</div>
      </div>
      <EditLinkToPill
        prefixId="step2"
        linkPathname="/investments/recommend-an-exchange-tiff/allocate"
        pageName="toPool"
        analyticsTracking={(value) => props.analyticsTracking && props.analyticsTracking(value)}
      />
      <CloseTag data-test="close-tag" onClick={props.closed}><img src={close} className="popover-close" /></CloseTag>
    </>
  );
  return renderInfoStep2();
};

export const RecurringStep1 = props => {
  const renderInfoStep1 = () => (
    <>
      <div>
        <div>Schedule: '()'Recurring Exchange 1</div>
        <div>Start Date: </div>
        <div>Frequency: </div>
        <div>Pools: </div>
        <div>No.of.Exchanges: </div>
      </div>
      <EditLinkToPill
        linkPathname="/recommendAnExchange/recommendAnExchangeFrom"
        pageName="fromPool"
      />
    </>
  );
  return renderInfoStep1();
};

export const RecurringStep2 = props => {
  const renderInfoStep2 = () => (
    <>
      <div>
        <div>Schedule: Recurring Exchange 2</div>
        <div>Total Amount Allocated </div>
        <div>Pools: </div>
      </div>
      <EditLinkToPill
        prefixId="recurring"
        linkPathname="/recommendAnExchange/recommendAnExchangeTo"
        pageName="toPool"
      />
    </>
  );
  return renderInfoStep2();
};
